import React, {useCallback, useEffect, useState} from 'react'
import {Dialog, Input, InputAdornment, OutlinedInput, Slide, SlideProps} from "@mui/material";
import {AxiosError} from "axios";
import {useQuery} from "@tanstack/react-query";
import DialogHeader from "@/view/layout/DialogHeader";
import HeaderSpacer from "@/view/layout/HeaderSpacer";
import BottomButton from "@/view/common/component/button/BottomButton";
import BoardService, {BoardData, BoardItem} from "@/service/BoardService";
import {USER_ID} from "@/common/Constant";
import StringUtil from "@/common/StringUtil";
import StorageUtil from "@/common/StorageUtil";
import {history} from "@/view/common/component/History";
import Confirm from "@/view/common/popup/Confirm";
import BoardAddComplete from "@/view/board/BoardAddComplete";

export interface BoardAddParam {
    onClose: () => void,
    onReturn: () => void
}

const Transition = React.forwardRef(function Transition(
    props: SlideProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const BoardAdd = (props: BoardAddParam) => {
    const handleOverlayClick = useCallback(() => props.onClose(), [props.onClose])
    const handleReturnClick = useCallback(() => {props.onReturn()}, [props.onReturn])
    const [open, setOpen] = React.useState(false)
    const titleMaxLength = 20
    const contentMaxLength = 1000
    const [titleLength, setTitleLength] = useState(0)
    const [contentLength, setContentLengh] = useState(0)
    const [boardItem, setBoardItem] = useState({ title: "", content: ""})
    const [registItem, setRegistItem] = useState<BoardItem>()
    let registFlag = false
    const [isOpen, setIsOpen] = useState(false)
    const [regable] = useState(StorageUtil.getLocalStorage(USER_ID) === '1')

    useEffect(() => {
        const unlistenHistoryEvent = history.listen(({ action }) => {
            if (action === 'POP') {
                checkIsChanged()
            }
        });

        return unlistenHistoryEvent;

    }, [history])

    const checkIsChanged = () => {
        if(StringUtil.isNotEmpty(boardItem.title) || StringUtil.isNotEmpty(boardItem.content)){
            setIsOpen(true)
        }else{
            handleOverlayClick()
        }
    }

    const inputChanged = (event: { target: { id: string; value: string; }; }) => {
        const { id, value } = event.target
        setBoardItem({ ...boardItem, [id]: value })
        if(id === 'title' && value !== undefined){
            setTitleLength(value.length)

        }else if(id === 'content' && value !== undefined){
            setContentLengh(value.length)
        }
    }

    const {refetch:postBoard} = useQuery<BoardData, AxiosError>(
        ['postBoard'],
        ()=> BoardService.postBoard(registItem),
        {
            onSuccess: (v: BoardData) => {setOpen(true)}
        }
    )

    const registBoard = () => {
        const userId = StorageUtil.getLocalStorage(USER_ID) as unknown as number
        setRegistItem({
            title: boardItem.title,
            content: boardItem.content,
            writerId: userId,
        })
    }

    useEffect(()=> {
        if(registItem !== undefined) {
            if(registFlag){
                return
            }
            registFlag = true
            postBoard()
                .then(r => {
                    registFlag = false
                    return Promise<void>
                })
                .catch(reason => {
                    console.log(reason)
                })
        }
    }, [registItem])

    return <>
        <DialogHeader onClose={checkIsChanged} title={'문의등록'}/>
        <div className={'board'}>
            <HeaderSpacer/>
            <Input className={'b2_r w-100p h-22px mt-39px mb-24px'}
                   id={'title'}
                   required={true}
                   placeholder={'제목을 입력해주세요'}
                   inputProps={{ maxLength: titleMaxLength}}
                   endAdornment={<InputAdornment className={'c1_r'} position="end">{titleLength}/{titleMaxLength}</InputAdornment>}
                   onChange={inputChanged}
            />
            <OutlinedInput className={'b2_r w-100p'}
                           style={{flexDirection: 'column', alignItems : 'flex-end'}}
                           id={'content'}
                           required={true}
                           placeholder={'내용을 입력해주세요'}
                           rows={10}
                           multiline={true}
                           inputProps={{ maxLength: contentMaxLength}}
                           endAdornment={<InputAdornment className={'c1_r'} position="end">{contentLength}/{contentMaxLength}</InputAdornment>}
                           onChange={inputChanged}
            />
        </div>
        {boardItem.title === '' || boardItem.content === ''
            ? <BottomButton className={'primary'} disabled={true} title={'글 등록하기'}/>
            : <BottomButton className={'primary'} disabled={!regable} title={'글 등록하기'} onClick={registBoard}/>
        }
        <Dialog fullScreen open={open} onClose={handleReturnClick} TransitionComponent={Transition}>
            {<BoardAddComplete onClose={handleReturnClick}/>}
        </Dialog>
        <Confirm content={<span>작성 중인 내용이 사라집니다<br/>그래도 나가시겠습니까?</span>} title={undefined} leftBtnContent={'아니오'} rightBtnContent={'네'} isOpen={isOpen} onClick={ () => setIsOpen(false)} onClose={ () => props.onClose()}/>
    </>
}

export default BoardAdd
